document.querySelectorAll('.tabs button').forEach((button) => button.addEventListener('click', () => {
  const image = document.querySelector('#stitch-image');
  const caption = document.querySelector('#stitch-caption');
  if (image) {
    const base = image.src.replace(/[^/]+(?:\?.*)?$/, '');
    image.src = base + button.dataset.image;
  }
  if (caption && button.dataset.caption) caption.textContent = button.dataset.caption;
}));

document.querySelectorAll('[data-home-filter]').forEach((button) => button.addEventListener('click', () => {
  const filter = button.dataset.homeFilter;
  document.querySelectorAll('[data-home-filter]').forEach((item) => item.classList.toggle('active', item === button));
  document.querySelectorAll('[data-home-category]').forEach((card) => {
    card.hidden = filter !== 'all' && card.dataset.homeCategory !== filter;
  });
}));

document.querySelectorAll('[data-collection-filter]').forEach((button) => button.addEventListener('click', () => {
  const filter = button.dataset.collectionFilter;
  document.querySelectorAll('[data-collection-filter]').forEach((item) => item.classList.toggle('active', item === button));
  document.querySelectorAll('[data-collection-category]').forEach((card) => {
    card.hidden = filter !== 'all' && card.dataset.collectionCategory !== filter && card.dataset.collectionMaterial !== filter;
  });
}));

const requestedCollectionFilter = new URLSearchParams(window.location.search).get('sk_filter');
if (requestedCollectionFilter) {
  const matchingFilter = [...document.querySelectorAll('[data-collection-filter]')].find((button) => button.dataset.collectionFilter === requestedCollectionFilter);
  if (matchingFilter) matchingFilter.click();
}

const drawer = document.querySelector('.sk-cart-drawer');
const scrim = document.querySelector('.sk-cart-scrim');
const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);

function openDrawer() {
  if (!drawer || !scrim) return;
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  scrim.hidden = false;
}

function closeDrawer() {
  if (!drawer || !scrim) return;
  drawer.classList.remove('open');
  drawer.setAttribute('aria-hidden', 'true');
  scrim.hidden = true;
}

async function renderCart(open = false) {
  if (!drawer) return;
  const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  const cart = await response.json();
  const items = drawer.querySelector('[data-cart-items]');
  const total = drawer.querySelector('[data-cart-total]');
  if (total) total.textContent = money(cart.total_price);
  document.querySelectorAll('.sk-cart').forEach((link) => { link.textContent = link.textContent.replace(/\(\d+\)/, `(${cart.item_count})`); });
  if (items) {
    items.innerHTML = cart.items.length ? cart.items.map((item, index) => `<article class="sk-drawer-item"><img src="${item.image || ''}" alt=""><div><h3>${item.product_title}</h3><p>${item.variant_title || ''}</p><p>${item.quantity} × ${money(item.final_price)}</p></div><button class="sk-drawer-remove" type="button" data-cart-remove="${index + 1}" aria-label="Entfernen">×</button></article>`).join('') : '<p>Noch ist es ruhig hier.</p>';
  }
  if (open) openDrawer();
}

document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
document.querySelectorAll('.sk-cart').forEach((link) => link.addEventListener('click', (event) => { event.preventDefault(); renderCart(true); }));
document.addEventListener('click', async (event) => {
  const remove = event.target.closest('[data-cart-remove]');
  if (!remove) return;
  await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(remove.dataset.cartRemove), quantity: 0 }) });
  renderCart(true);
});

document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => form.addEventListener('submit', async (event) => {
  event.preventDefault();
  const submit = form.querySelector('[type="submit"]');
  if (submit) submit.disabled = true;
  try {
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('add failed');
    await renderCart(true);
  } catch (error) {
    form.submit();
  } finally {
    if (submit) submit.disabled = false;
  }
}));

// PDP: enhance the native Shopify form; the select and standard submission remain fallbacks.
const productForm = document.querySelector('#sk-buy-form');
if (productForm) {
  const variantSelect = productForm.querySelector('select[name="id"]');
  const variantPicker = productForm.querySelector('.sk-variant-picker');
  const variantButtons = [...productForm.querySelectorAll('[data-sk-variant]')];
  const quantityInput = productForm.querySelector('input[name="quantity"]');
  const priceLabel = document.querySelector('[data-sk-current-price]');
  const buyPrice = productForm.querySelector('[data-sk-buy-price]');
  const stickyPrice = document.querySelector('[data-sk-sticky-price]');
  const nightPrice = document.querySelector('[data-sk-night-price]');
  const nightPriceWrap = document.querySelector('[data-sk-night-count]');
  const shippingProgress = document.querySelector('[data-sk-shipping-target]');
  const submitButton = productForm.querySelector('button[type="submit"]');

  const updateVariant = () => {
    if (!variantSelect) return;
    const selected = variantButtons.find((button) => button.dataset.skVariant === variantSelect.value);
    variantButtons.forEach((button) => button.setAttribute('aria-pressed', String(button === selected)));
    if (!selected) return;
    const cents = Number(selected.dataset.skPrice);
    if (priceLabel) priceLabel.textContent = money(cents);
    if (buyPrice) buyPrice.textContent = money(cents);
    if (stickyPrice) stickyPrice.textContent = money(cents);
    if (nightPrice && nightPriceWrap) nightPrice.textContent = money(Math.round(cents / Number(nightPriceWrap.dataset.skNightCount || 300)));
    if (submitButton) submitButton.disabled = selected.dataset.skAvailable !== 'true';
    if (shippingProgress) {
      const target = Number(shippingProgress.dataset.skShippingTarget);
      const fill = shippingProgress.querySelector('div span');
      const label = shippingProgress.querySelector('p');
      if (fill && target > 0) fill.style.width = `${Math.min(100, cents / target * 100)}%`;
      if (label && target > 0) label.textContent = cents >= target ? shippingProgress.dataset.skShippingReached : `Noch ${money(target - cents)} bis zum kostenlosen Versand`;
    }
  };

  if (variantPicker && variantSelect) {
    variantPicker.classList.add('is-enhanced');
    variantButtons.forEach((button) => button.addEventListener('click', () => {
      variantSelect.value = button.dataset.skVariant;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    variantSelect.addEventListener('change', updateVariant);
    updateVariant();
  }
  productForm.querySelectorAll('[data-sk-quantity]').forEach((button) => button.addEventListener('click', () => {
    const current = Math.max(1, Number(quantityInput.value) || 1);
    quantityInput.value = button.dataset.skQuantity === 'plus' ? current + 1 : Math.max(1, current - 1);
  }));
  document.querySelector('[data-sk-sticky-buy]')?.addEventListener('click', () => {
    if (!submitButton || submitButton.disabled) return;
    productForm.requestSubmit(submitButton);
  });
  productForm.querySelector('[data-sk-buy-now]')?.addEventListener('click', async (event) => {
    const button = event.currentTarget;
    button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(productForm) });
      if (!response.ok) throw new Error('add failed');
      window.location.href = '/checkout';
    } catch (error) {
      button.disabled = false;
      productForm.requestSubmit(submitButton);
    }
  });
}

const sizeDialog = document.querySelector('[data-sk-size-dialog]');
document.querySelector('[data-sk-size-open]')?.addEventListener('click', () => sizeDialog?.showModal());
document.querySelector('[data-sk-size-close]')?.addEventListener('click', () => sizeDialog?.close());
sizeDialog?.addEventListener('click', (event) => { if (event.target === sizeDialog) sizeDialog.close(); });

document.querySelectorAll('[data-sk-quick-open]').forEach((button) => button.addEventListener('click', () => document.getElementById(button.dataset.skQuickOpen)?.showModal()));
document.querySelectorAll('[data-sk-quick-close]').forEach((button) => button.addEventListener('click', () => button.closest('dialog')?.close()));
document.querySelectorAll('.sk-quick-dialog').forEach((dialog) => {
  dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  dialog.querySelector('form')?.addEventListener('submit', () => dialog.close());
});

document.querySelectorAll('[data-sk-quiz-dialog]').forEach((quizDialog) => {
  const form = quizDialog.querySelector('[data-sk-quiz]');
  const steps = [...quizDialog.querySelectorAll('[data-sk-quiz-step]')];
  const back = quizDialog.querySelector('[data-sk-quiz-back]');
  const next = quizDialog.querySelector('[data-sk-quiz-next]');
  const submit = quizDialog.querySelector('[data-sk-quiz-submit]');
  const progress = quizDialog.querySelector('[data-sk-quiz-progress]');
  const progressBar = quizDialog.querySelector('[data-sk-quiz-progress-bar]');
  let step = 0;
  const paintStep = () => {
    steps.forEach((item, index) => item.classList.toggle('is-active', index === step));
    back.disabled = step === 0;
    next.hidden = step === steps.length - 1;
    submit.hidden = step !== steps.length - 1;
    progress.textContent = `0${step + 1} / 0${steps.length}`;
    progressBar.style.width = `${((step + 1) / steps.length) * 100}%`;
  };
  const currentChoiceExists = () => Boolean(steps[step].querySelector('input:checked'));
  next.addEventListener('click', () => { if (!currentChoiceExists()) { steps[step].classList.add('has-error'); return; } steps[step].classList.remove('has-error'); step += 1; paintStep(); });
  back.addEventListener('click', () => { step = Math.max(0, step - 1); paintStep(); });
  steps.forEach((item) => item.addEventListener('change', () => item.classList.remove('has-error')));
  quizDialog.querySelector('[data-sk-quiz-close]')?.addEventListener('click', () => quizDialog.close());
  quizDialog.addEventListener('click', (event) => { if (event.target === quizDialog) quizDialog.close(); });
  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    if (!currentChoiceExists()) { steps[step].classList.add('has-error'); return; }
    const data = new FormData(event.currentTarget);
    let handle = 'welle-01';
    if (data.get('priority') === 'natural') handle = data.get('temperature') === 'warm' ? 'leinen-01' : 'musselin-02';
    else if (data.get('temperature') === 'flexible') handle = 'duo-04';
    else if (data.get('temperature') === 'cold') handle = 'chevron-03';
    else if (data.get('style') === 'organic') handle = 'blatt-01';
    else if (data.get('style') === 'sculptural') handle = 'bogen-02';
    else if (data.get('style') === 'graphic') handle = 'chevron-03';
    window.location.href = `/products/${handle}`;
  });
  quizDialog.addEventListener('close', () => { form?.reset(); step = 0; paintStep(); });
  paintStep();
});
document.querySelectorAll('[data-sk-quiz-open]').forEach((button) => button.addEventListener('click', () => {
  const localDialog = button.closest('section')?.nextElementSibling;
  const dialog = localDialog?.matches?.('[data-sk-quiz-dialog]') ? localDialog : document.querySelector('[data-sk-quiz-dialog]');
  dialog?.showModal();
}));

const exitDialog = document.querySelector('[data-sk-exit-dialog]');
if (exitDialog && sessionStorage.getItem('skExitSeen') !== '1') {
  document.addEventListener('mouseout', (event) => {
    if (event.clientY > 8 || event.relatedTarget) return;
    sessionStorage.setItem('skExitSeen', '1');
    exitDialog.showModal();
  }, { once: true });
}
document.querySelector('[data-sk-exit-close]')?.addEventListener('click', () => exitDialog?.close());

document.querySelectorAll('[data-sk-gallery]').forEach((gallery) => {
  const slides = [...gallery.querySelectorAll('[data-sk-gallery-slide]')];
  const thumbs = [...gallery.querySelectorAll('[data-sk-gallery-thumb]')];
  const dialog = document.querySelector('[data-sk-image-dialog]');
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
    const index = thumb.dataset.skGalleryThumb;
    slides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.skGallerySlide === index));
    thumbs.forEach((item) => {
      const active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
  }));
  slides.forEach((slide) => slide.addEventListener('click', () => {
    const image = slide.querySelector('img');
    const enlarged = dialog?.querySelector('img');
    if (!image || !enlarged || !dialog?.showModal) return;
    enlarged.src = image.currentSrc || image.src;
    enlarged.alt = image.alt;
    dialog.showModal();
  }));
  dialog?.querySelector('[data-sk-image-close]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
});
